import { EditarPrecoTintaController } from "app/controllers/orcamento/editarPrecoTintaController.js";
import { SimularDescontoItemOrcamentoController } from "app/controllers/orcamento/simularDescontoItemOrcamentoController";
import { VendaProdutoEstoqueIndisponivel } from "app/controllers/orcamento/vendaProdutoEstoqueIndisponivel.js";
import { parametroSistema } from "app/controllers/parametros/parametroController.js";
import { alterarDataMarcadaEntregaItem } from "app/use-cases/orcamento/alterarDataMarcadaEntregaItem";
import { alterarDataPrevisaoEntregaItem } from "app/use-cases/orcamento/alterarDataPrevisaoEntregaItem";
import { alterarPrecoItem } from "app/use-cases/orcamento/alterarPrecoItem";
import { alterarQuantidadeItem } from "app/use-cases/orcamento/alterarQuantidadeItem";
import { alterarTipoEntregaItem } from "app/use-cases/orcamento/alterarTipoEntregaItem";
import { alterarTurnoEntregaItem } from "app/use-cases/orcamento/alterarTurnoEntregaItem";
import { definirOidModalidadeEntregaItem } from "app/use-cases/orcamento/definirOidModalidadeEntregaItem"; // 402445
import { definirIdPontoRetiradaItem } from "app/use-cases/orcamento/definirIdPontoRetiradaItem"; // 402445
import { definirFilialRetiradaItem } from "app/use-cases/orcamento/definirFilialRetiradaItem";
import { definirFilialTransferenciaItem } from "app/use-cases/orcamento/definirFilialTransferenciaItem";
import { definirPedidoDeCompraItem } from "app/use-cases/orcamento/definirPedidoDeCompraItem";
import { definirTipoFaturamentoItem } from "app/use-cases/orcamento/definirTipoFaturamentoItem";
import { definirVendaSobEncomendaItem } from "app/use-cases/orcamento/definirVendaSobEncomendaItem";
import { substituirDataMarcadaDataPrevisaoEntregaItens } from "app/use-cases/orcamento/substituirDataMarcadaDataPrevisaoEntregaItens";
import global from 'globalMU'
import {definirPreservaDesconto} from "../../use-cases/orcamento/definirPreservaDesconto";


import { obterItemOrcamentoDaStore } from "app/redux/utils/obterItemOrcamentoDaStore";
import { obterParametro } from "app/use-cases/parametro/obterParametro";
import microuniversoApi from "../../api/microuniversoApi";
import {DefinirMotivoDescontoItem} from "../../use-cases/orcamento/DefinirCodigoMotivoDescontoItem";
import store from "../../redux/store/store";
import {IItemOrcamento} from "../../types/IItemOrcamento";


declare var window: any

const Backbone = require('backbone')

const EditarItemOrcamentoView = Backbone.Marionette.CompositeView.extend({
    template: "#template-editar-item-orcamento",
    form: "#form-editar-item-orcamento",
    name: "EditarItemOrcamentoView",
    templateCache: false, // FNX-1241

    initialize: function (options) {
        this.app = options.app;
        this.parent = options.parent;
        this.finalizarEdicaoItemCallback = options.finalizarEdicaoItemCallback;
        this.cancelarEdicaoItemCallback = options.cancelarEdicaoItemCallback;
        this.itemExcluidoCallback = options.itemExcluidoCallback;

        this.model.orcamento.on("change:ValorDespesasInclusas", this.habilitarDespesasInclusas, this);
        this.model.on("change:Atualizar", this.atualizar, this);
        this.model.on("change:AtualizarVendaSobEncomenda", this.obterEncomendaItemOrcamento, this);

        parametroSistema.obter("TRATAR_VENDAS_SOB_ENCOMENDA",
            $.proxy(function (p) {
                this.parametroTratarVendaSobEncomenda = p;
            },
                this));
    },
    ui: {
        descricaoProduto: "input[name=DescricaoProduto]",
        quantidade: "input[name=Quantidade]",
        despesasInclusas: "input[name=DespesasInclusas]",
        ofertaSelecionada: "input[name=OfertaSelecionada]",
        tipoEntrega: "select[name=CodigoTipoEntrega]",
        turnoEntrega: "select[name=TurnoEntrega]",
        dataPrevisaoEntrega: "input[name=DataPrevisaoEntrega]",
        dataMarcadaEntrega: "input[name=DataMarcadaEntrega]",
        entregaPosterior: "input[name=EntregaPosterior]",
        vendaSobEncomenda: "input[name=VendaSobEncomenda]",
        codigoFilialRetirada: "select[name=CodigoFilialRetirada]",
        codigoFilialTransferencia: "select[name=CodigoFilialTransferencia]",
        tipoFaturamento: "select[name=TipoFaturamento]",

        oidModalidadeEntregaItem: "select[name=ComboboxOidModalidadeEntregaItem]", // 402445
        idPontoRetiradaItem: "select[name=ComboboxIdPontoRetiradaItem]", // 402445


        precoProduto: "input[name=PrecoProduto]",
        simularDesconto: "#button-simular-desconto",
        substituirDataMarcadaDataPrevisaoEntregaItens: "#button-substituir-datas-outros-itens",
        pedidoCompraCliente: "input[name=PedidoCompraCliente]",
        aliquotaIPI: "input[name=AliquotaIPI]",
        valorIPI: "input[name=ValorIPI]",
        vendaProdutoEstoqueIndisponivel: "#venda-produto-estoque-indisponivel",
        pedidoCompraClienteItem: "input[name=PedidoCompraClienteItem]",
        desativaRegimeEspecial: "input[name=RegimeEspecial]",
        preservaDesconto: "input[name=PreservaDesconto]"
    },

    events: {
        'click #aplicar-editar-item-orcamento': "aplicar",
        'click #editar-preco-tinta': "editarPrecoTinta",
        'click #button-simular-desconto': "simularDesconto",
        'click #button-substituir-datas-outros-itens': "substituirDataMarcadaDataPrevisaoEntregaItens",
        'change input[name=DescricaoProduto]': "alterarDescricaoProduto",
        'blur input[name=Quantidade]': "alterarQuantidade",
        'blur input[name=PrecoProduto]': "alterarPrecoProduto",
        'change input[name=DespesasInclusas]': "alterarDespesasInclusas",
        'change input[name=OfertaSelecionada]': "alterarOfertaSelecionada",
        'change select[name=CodigoTipoEntrega]': "alterarTipoEntrega",
        'change select[name=TurnoEntrega]': "alterarTurnoEntrega",
        'change input[name=EntregaPosterior]': "alterarEntregaPosterior",
        'change input[name=VendaSobEncomenda]': "alterarVendaSobEncomenda",
        'change input[name=PedidoCompraCliente]': "alterarPedidoCompraCliente",
        'change select[name=CodigoFilialRetirada]': "alterarCodigoFilialRetirada",

        'change select[name=ComboboxOidModalidadeEntregaItem]': "alterarOidModalidadeEntrega", // 402445
        'change select[name=ComboboxIdPontoRetiradaItem]': "alterarIdPontoRetirada", // 402445

        'change select[name=CodigoFilialTransferencia]': "alterarCodigoFilialTransferencia",
        'change select[name=TipoFaturamento]': "alterarTipoFaturamento",
        'change input[name=AliquotaIPI]': "alterarAliquotaIPI",
        'click #venda-produto-estoque-indisponivel': "vendaProdutoEstoqueIndisponivel",
        'change input[name=PedidoCompraClienteItem]': "alterarPedidoCompraClienteItem",
        'change input[name=RegimeEspecial]': "alterarDesativaRegimeEspecial",
    },

    obterSituacaoCheckboxPreservaDesconto: function() : {marcado: boolean, desabilitado: boolean} {
        return {
            marcado: this.model.get('PreservaDesconto') ?? false,
            desabilitado: this.model.get('ValorDesconto') == 0
        }
    },

    atualizarSituacaoCheckboxPreservaDesconto: function() {
        const situacaoCheckboxPreservaDesconto = this.obterSituacaoCheckboxPreservaDesconto()

        $("#PreservaDesconto").prop('disabled', situacaoCheckboxPreservaDesconto.desabilitado)
        $("#PreservaDesconto").prop('checked', situacaoCheckboxPreservaDesconto.marcado)
    },

    atualizar: function () {

        if (this.isDestroyed) {
            return;
        }

        this.render();
        this.iniciarView(false);

    },

    onShow: function () {

        this.iniciarView();
    },

    iniciarView: async function (iniciarFoco) {

        const identificador = this.model.get('Identificador')
        const itemAtual = (window.store.getState().orcamento.ItensOrcamento as IItemOrcamento[]).find(i => i.Identificador === identificador)

        $("input").on('focus', function () { $(this).select(); });
        
        const motivos = await microuniversoApi.Orcamento.obterMotivosDesconto()
        
        
        for (const motivo of motivos) {
            $('#motivo-desconto-select').append(new Option(motivo.Motivo, motivo.Codigo.toString()))
        }
        $(`#motivo-desconto-select option[value=${itemAtual.CodigoMotivoDesconto}]`).prop('selected', true)
        $('#motivo-desconto-select').change(async function(){
            const valor = $(this).val();
            await DefinirMotivoDescontoItem({
                codigoMotivoDesconto: valor,
                identificadorItem: identificador
            })
        })

        $("#PreservaDesconto").on('change', () => this.alterarPreservaDesconto())

        this.ui.dataPrevisaoEntrega.closest("[calendar]").on("dp.change", $.proxy(this.alterarDataPrevisaoEntrega, this));
        this.ui.dataMarcadaEntrega.closest("[calendar]").on("dp.change", $.proxy(this.alterarDataMarcadaEntrega, this));

        this.configurarForm();
        //$('#DespesasInclusas').attr("checked", this.model.get('DespesasInclusas'));
        this.habilitarDespesasInclusas();

        this.habilitarOfertaSeletiva();

        if (this.model.get("CodigoTipoEntrega")) {
            this.ui.tipoEntrega.val(this.model.get("CodigoTipoEntrega"));
        }

        if (typeof this.model.get("TurnoEntrega") != "undefined") {
            this.ui.turnoEntrega.val(this.model.get("TurnoEntrega"));
        }

        if (typeof iniciarFoco == "undefined" || iniciarFoco) {
            this.ui.quantidade.focus();
        }

        if (this.model.get("CodigoFilialRetirada")) {
            this.ui.codigoFilialRetirada.val(this.model.get("CodigoFilialRetirada"));
        }

        if (this.model.get("OidModalidadeEntrega")) { // 402445
            this.ui.oidModalidadeEntregaItem.val(this.model.get("OidModalidadeEntrega"));
        }
        if (this.model.get("IdPontoRetirada")) {  // 402445
            this.ui.idPontoRetiradaItem.val(this.model.get("IdPontoRetirada"));
        }

        if (this.model.get("CodigoFilialTransferencia")) {
            this.ui.codigoFilialTransferencia.val(this.model.get("CodigoFilialTransferencia"));
        }

        const itemOrcamentoDaStore = obterItemOrcamentoDaStore(this.model.get('Identificador'))
        this.model.set('PreservaDesconto', itemOrcamentoDaStore?.PreservaDesconto ?? false)
        this.model.set('ValorDesconto', itemOrcamentoDaStore?.ValorDesconto)

        // FNX-450
        // if (this.model.get('TipoFaturamento')) {
        this.ui.tipoFaturamento.val(this.model.get("TipoFaturamento"));
        // }

        //this.ui.tipoFaturamento.prop("disabled", !this.model.get("CodigoFilialRetirada"));
        this.ui.idPontoRetiradaItem.prop("disabled", (this.model.get("OidModalidadeEntrega") != "39669"));  // 402445

        // FNX-433, FNX-434
        this.ui.precoProduto.prop("disabled", !this.model.get("PermiteAlterarPreco"));
        if (!this.model.get("PermiteAlterarPreco") && parametroSistema.obter("BLOQUEIA_DESCONTO_UNITARIO_NO_ORCAMENTO").Valor === "S") // ficha 413014
        {
            this.ui.simularDesconto.hide();
        }

        this.atualizarSituacaoCheckboxPreservaDesconto()
    },

    configurarForm: function () {

        this.validationOptions = {
            errorClass: "erro",
            onkeyup: false,
            errorPlacement: function (error, element) {
                return true;
            },
            focusInvalid: false,
            invalidHandler: function (event, validator) {

                var errors = validator.numberOfInvalids();

                if (errors) {
                    var messages = new Array();

                    $.each(validator.errorList,
                        function () {
                            messages.push(this.message);
                        });

                    global.showErrorMessage(messages);

                    return false;
                }
            },
            rules: {
                'Quantidade': {
                    required: true
                },
                'DataPrevisaoEntrega': {
                    validateDate: true
                    //dateGreaterOrEqualThanActualDate: true
                },
                'DataMarcadaEntrega': {
                    validateDate: true
                    //dateGreaterOrEqualThanActualDate: true
                }
            },
            messages: {
                'Quantidade': {
                    required: 'O campo "quantidade" é obrigatório.'
                },
                'DataPrevisaoEntrega': {
                    validateDate: 'O campo "Data Prevista" é inválido.'
                    //dateGreaterOrEqualThanActualDate: 'O campo "Data Prevista" deve ser maior ou igual a data atual.'
                },
                'DataMarcadaEntrega': {
                    validateDate: 'O campo "Data Marcada" é inválido.'
                    //dateGreaterOrEqualThanActualDate: 'O campo "Data Marcada" deve ser maior ou igual a data atual.'
                }
            }
        };

        $(this.form).validate(this.validationOptions);

    },

    habilitarDespesasInclusas: function () {

        var valorDespesasInclusas = this.model.orcamento.get("ValorDespesasInclusas");

        var input = $("input[name=DespesasInclusas]", this.$el);

        if (valorDespesasInclusas && valorDespesasInclusas > 0) {
            input.prop("disabled", false);
        } else {
            input.prop("checked", false);
            input.prop("disabled", true);
        }

    },

    habilitarOfertaSeletiva: function () {

        var operacao = this.model.orcamento.get("TipoOrcamentoDescricao");

        var input = $("input[name=OfertaSelecionada]", this.$el);

        // if (operacao && operacao == 'Venda' && this.model.get("Cor") == '#0000FF') { // Oferta cor azul

        if (operacao && operacao == 'Venda' && this.model.get("OidOferta") > 0) { // Oferta cor azul --- FNX-5659
            input.prop("disabled", false);
        } else {
            input.prop("checked", false);
            input.prop("disabled", true);
        }

    },

    aplicar: function () {

        if (!$(this.form).valid()) {
            return false;
        }

        var formdata = global.convertFormToJSON({
            element: $(this.form)
        });

        this.model.alterarItem(formdata, $.proxy(this.quantidadeAlterada, this));
    },

    simularDesconto: function (e) {

        e.preventDefault();

        this.simularDescontoItemOrcamentoController = new SimularDescontoItemOrcamentoController({
            modal: "#modalSimularDesconto",
            model: this.model.toJSON(),
            itemOrcamento: this.model,
            controller: this.controller
        });

        this.simularDescontoItemOrcamentoController.show();

    },

    substituirDataMarcadaDataPrevisaoEntregaItens: async function () {
        // this.model.substituirDataMarcadaDataPrevisaoEntregaItens();

        await substituirDataMarcadaDataPrevisaoEntregaItens({
            dataMarcadaEntrega: this.model.get('DataMarcadaEntrega')
        })

        this.atualizar()

        for (let i = 0; i < this.model.collection.length; i++) {
            this.model.collection.models[i].attributes.DataMarcadaEntrega = this.model.orcamento.attributes.ItensOrcamento.models[i].attributes.DataMarcadaEntrega;
            this.model.collection.models[i].attributes.DataPrevisaoEntrega = this.model.orcamento.attributes.ItensOrcamento.models[i].attributes.DataMarcadaEntrega;
        }
    },

    vendaProdutoEstoqueIndisponivel: function (e) {

        e.preventDefault();

        if (this.model && this.model.orcamento.get("TipoOrcamento") == 2) { // transferencia
            return
        }

        this.vendaProdutoEstoqueIndisponivel = this.controller.showView({
            region: {
                name: "vendaProdutoEstoqueIndisponivelRegion",
                selector: "#venda-produto-estoque-indisponivel-region"
            },
            controller: {
                type: VendaProdutoEstoqueIndisponivel,
                args: {
                    itemOrcamento: this.model,
                    itemExcluidoCallback: $.proxy(this.itemExcluido, this)
                }
            }
        });
    },

    itemExcluido: function (data) {
        this.vendaProdutoEstoqueIndisponivel.hide();
        this.controller.hide();

        if (this.itemExcluidoCallback) {
            this.itemExcluidoCallback(data);
        }
    },

    editarPrecoTinta: function (e) {
        e.preventDefault();

        this.editarPrecoTintaController = this.controller.showView({
            region: {
                name: "editarPrecoTintaRegion",
                selector: "#editar-preco-tinta-region"
            },
            controller: {
                type: EditarPrecoTintaController,
                args: {
                    itemOrcamento: this.model,
                    finalizarCallback: $.proxy(this.finalizarEdicaoPrecoTinta, this)

                }
            }
        });

    },

    finalizarEdicaoPrecoTinta: function () {

        this.editarPrecoTintaController.hide();
        this.controller.show();

    },

    quantidadeAlterada: function () {

        global.showSuccessMessage("Item alterado com sucesso.");


        if (this.finalizarEdicaoItemCallback) {
            this.finalizarEdicaoItemCallback();
        }
    },

    alterarDescricaoProduto: function () {

        var descricao = this.ui.descricaoProduto.val();

        if (descricao.length == 0) {
            global.showErrorMessage('O campo "Descrição" é obrigatório.');
            return;
        }

        this.model.set("DescricaoProduto", descricao);

    },

    alterarPreservaDesconto: async function () {

        const parametro_PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO = await obterParametro({nome: "PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO"})

        if (parametro_PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO == "S") {
            await definirPreservaDesconto({
                identificadorItem: this.model.get('Identificador'),
                preservaDesconto: !(this.model.get('PreservaDesconto') ?? false)
            })

            this.model.set('PreservaDesconto',obterItemOrcamentoDaStore(this.model.get('Identificador'))?.PreservaDesconto, { silent: true })
        }
        
        

        

        this.atualizarSituacaoCheckboxPreservaDesconto()
    },

    alterarQuantidade: async function () {

        var quantidade = this.ui.quantidade.val();

        if (global.unformatNumber(quantidade) === global.unformatNumber(this.model.get('Quantidade'))) {
            return;
        }

        if (!global.validateNumberMaxValue("double", quantidade)) {
            global.showErrorMessage('O valor do campo "Quantidade" é muito grande e não é suportado.');
            return;
        }

        this.model.set("Quantidade", quantidade, { silent: true });

        await alterarQuantidadeItem({
            identificadorItem: this.model.get('Identificador'),
            quantidade: global.unformatNumber(quantidade),
            quantidadeEstoque: this.model.get('QuantidadeEstoque'),
            quantidadeSolicitada: this.model.get('QuantidadeSolicitada'),
            atualizarEstadoLegadoImediatamente: true
        })
    },

    alterarPrecoProduto: async function () {
        var preco = this.ui.precoProduto.val();
        var percentualDesconto = this.ui.PercentualDesconto?.val();
        var percentualBonificacao = this.ui.PercentualBonificacao?.val();

        if (global.unformatNumber(preco) === global.unformatNumber(this.model.get('PrecoProduto'))) {
            return;
        }

        if (!global.validateNumberMaxValue("double", preco)) {
            global.showErrorMessage('O valor do campo "Preço" é muito grande e não é suportado.');
            return;
        }

        
        await alterarPrecoItem({
            identificadorItem: this.model.get('Identificador'),
            preco: preco,
            percentualDesconto: percentualDesconto,
            percentualBonificacao: percentualBonificacao,
            atualizarEstadoLegadoImediatamente: true
        })

        const itemOrcamentoDaStore = obterItemOrcamentoDaStore(this.model.get('Identificador'))
        this.model.set('PreservaDesconto',itemOrcamentoDaStore?.PreservaDesconto)
        this.model.set("PrecoProduto", preco, { silent: true })
        this.model.set("PercentualDesconto", itemOrcamentoDaStore?.PercentualDesconto ?? 0, { silent: true })
        this.model.set('ValorDesconto',itemOrcamentoDaStore?.ValorDesconto ?? 0, { silent: true })

        this.atualizarSituacaoCheckboxPreservaDesconto()
        
    },

    alterarDespesasInclusas: function () {
        var despesasInclusas = this.ui.despesasInclusas.prop("checked");
        this.model.set("DespesasInclusas", despesasInclusas);
    },
    alterarOfertaSelecionada: async function () {
        var ofertaSelecionada = this.ui.ofertaSelecionada.prop("checked");
        this.model.set("OfertaSelecionada", ofertaSelecionada);
    },

    alterarTipoEntrega: async function () {
        global.blockUI()
        var codigoTipoEntrega = this.ui.tipoEntrega.val();
        

        await alterarTipoEntregaItem({
            codigoTipoEntrega: codigoTipoEntrega,
            identificadorItem: this.model.get('Identificador'),
            itemOrcamento: this.model
        })

        this.atualizar()

        global.unblockUI()
    },

    alterarDataPrevisaoEntrega: async function () {

        if (global.applyingCalendars) {
            return;
        }

        var dataPrevisaoEntrega = this.ui.dataPrevisaoEntrega.val();

        if (dataPrevisaoEntrega && !global.validateDate(dataPrevisaoEntrega)) {
            global.showErrorMessage('O campo "Data Prevista" é inválido.');
            return;
        }

        if (dataPrevisaoEntrega && !global.dateGreaterOrEqualThanActualDate(dataPrevisaoEntrega)) {
            global.showErrorMessage('O campo "Data Prevista" deve ser maior ou igual a data atual.');
            return;
        }

        

        await alterarDataPrevisaoEntregaItem({
            dataPrevisaoEntrega,
            identificadorItem: this.model.get('Identificador'),
            itemLegado: this.model
        })

        this.atualizar()
    },

    alterarDataMarcadaEntrega: async function () {

        if (global.applyingCalendars) {
            return;
        }

        var dataMarcadaEntrega = this.ui.dataMarcadaEntrega.val();

        if (dataMarcadaEntrega && !global.validateDate(dataMarcadaEntrega)) {
            global.showErrorMessage('O campo "Data Marcada" é inválido.');
            return;
        }

        if (dataMarcadaEntrega && !global.dateGreaterOrEqualThanActualDate(dataMarcadaEntrega)) {
            global.showErrorMessage('O campo "Data Marcada" deve ser maior ou igual a data atual.');
            return;
        }

        

        await alterarDataMarcadaEntregaItem({
            dataMarcadaEntrega,
            identificadorItem: this.model.get('Identificador'),
            itemLegado: this.model
        })

        this.atualizar()
    },

    alterarTurnoEntrega: async function () {

        var turnoEntrega = this.ui.turnoEntrega.val();
        

        await alterarTurnoEntregaItem({
            identificadorItem: this.model.get('Identificador'),
            turnoEntrega,
            itemOrcamentoLegado: this.model
        })

        this.atualizar()

    },

    alterarEntregaPosterior: function () {
        var entregaPosterior = this.ui.entregaPosterior.prop("checked");
        this.model.set("EntregaPosterior", entregaPosterior);
    },

    obterEncomendaItemOrcamento: function () {
        var self = this;

        if (!this.model.get("VendaSobEncomenda") || this.model.get("CodigoTipoEntregaAlteradoAcoes")) {
            global.unblockUI();
            return;
        }

        global.ajax({
            url: "/Orcamento/ObterEncomendaItemOrcamento",
            type: "post",
            data: {
                identificadorOrcamento: this.model.get("IdentificadorOrcamento"),
                identificador: this.model.get("Identificador")
            },
            error: function () { global.unblockUI(); },
            success: function (data) {
                self.mostrarModalEncomenda(data);
                global.unblockUI();
            }
        });
    },

    mostrarModalEncomenda: function (data) {

        if (data && this.model.get("VendaSobEncomenda")
                && this.parametroTratarVendaSobEncomenda
                &&this.parametroTratarVendaSobEncomenda.Valor != "4")
        {
            data.ProdutoEncomendaComprarTotal = this.model.get("ProdutoEncomendaComprarTotal"); // 416558
            data.AdquirirQuantidadeTotalItem = this.model.get("AdquirirQuantidadeTotal");
            data.ParametroTratarVendaSobEncomenda = this.parametroTratarVendaSobEncomenda;
            data.EncomendaAutomatica = this.model.get("EncomendaAutomatica");
            data.habilitarAdquirirQuantidadeTotal = function ()
            {
                // FNX-979
                // 416558 - if (this.ParametroTratarVendaSobEncomenda.Valor == "4" || this.QuantidadeDisponivel <= 0)
                //     return false;
                // else {
                //     return data.EncomendaAutomatica;
                // }
                 
                var habilitar = this.ParametroTratarVendaSobEncomenda.Valor == "4" || this.QuantidadeDisponivel <= 0;
                if (this.ParametroTratarVendaSobEncomenda.Valor != "4")  // Ficha 416558 - PA: 378521 - ABC - 28/10/2020
                {
                    if (this.ProdutoEncomendaComprarTotal == true)
                        habilitar = false
                    else
                        habilitar = this.QuantidadeDisponivel > 0;
                }
                return habilitar

            };
            data.adquirirQuantidadeTotal = $.proxy(this.adquirirQuantidadeTotal, this);
            data.cancelar = $.proxy(this.cancelarModalEncomenda, this);
            this.controller.applyBindings(data, $("#modalVendaSobEncomenda")[0]);
            $("#modalVendaSobEncomenda").modal();
            if (this.parent.parent.itemOrcamentoView) {
                this.parent.parent.itemOrcamentoView.impedirAberturaModal = true; //fnx-5515
            }
            //$('.modal-backdrop').css('z-index', '-1');
        }
    },

    adquirirQuantidadeTotal: function (model) {

        this.model.set("AdquirirQuantidadeTotal", model.AdquirirQuantidadeTotalItem);
        this.model.adquirirQuantidadeTotalAlterado();

        $("#modalVendaSobEncomenda").modal("hide");
        $("body").removeClass("modal-open");
        $(".modal-backdrop").remove();

        //if (this.finalizarEdicaoItemCallback) { -- comentqdo fnx-5515
        //    this.finalizarEdicaoItemCallback();
        //}
        if (this.parent.parent.itemOrcamentoView) { //fnx-5515
            this.parent.parent.itemOrcamentoView.impedirAberturaModal = true;
        }
    },

    cancelarModalEncomenda: async function () {
        this.ui.vendaSobEncomenda.prop("checked", false);

        await definirVendaSobEncomendaItem({ // 419934
            identificadorItem: this.model.get("Identificador"),
            vendaSobEncomenda: this.ui.vendaSobEncomenda.prop("checked"),
            itemOrcamentoLegado: this.model
        })


    },

    alterarPedidoCompraCliente: function () {
        this.model.set("PedidoCompraCliente", this.ui.pedidoCompraCliente.val());

    },

    alterarPedidoCompraClienteItem: async function () {

        this.model.set("PedidoCompra", this.ui.pedidoCompraClienteItem.val(), { silent: true });

        await definirPedidoDeCompraItem({
            identificadorItem: this.model.get("Identificador"),
            pedidoDeCompra: this.ui.pedidoCompraClienteItem.val(),
            itemLegado: this.model
        })
    },

    alterarVendaSobEncomenda: async function () {

         
        //var vendaEnc =  this.ui.vendaSobEncomenda.prop("checked")
        //var vendaEncAnterior = this.model.get("VendaSobEncomendaAnterior")
        
        //this.model.set("VendaSobEncomenda", this.ui.vendaSobEncomenda.prop("checked"));
        await definirVendaSobEncomendaItem({
            identificadorItem: this.model.get("Identificador"),
            vendaSobEncomenda: this.ui.vendaSobEncomenda.prop("checked"),
            //vendaSobEncomenda: vendaEncAnterior,
            itemOrcamentoLegado: this.model
        })
 
        if (this.parametroTratarVendaSobEncomenda && this.parametroTratarVendaSobEncomenda.Valor != "4") {
            if (this.ui.vendaSobEncomenda.prop("checked")) {
                this.obterEncomendaItemOrcamento();
            }
        }
    },

    alterarDesativaRegimeEspecial: function () {
        if (this.ui.desativaRegimeEspecial.prop("checked")) {
            this.model.set("DesativaRegimeEspecial", 1);
        }
        else {
            this.model.set("DesativaRegimeEspecial", 0);
        }
    },

    alterarOidModalidadeEntrega: async function () { // 402445
        var oidModalidadeEntregaItem = this.ui.oidModalidadeEntregaItem.val();
        if (oidModalidadeEntregaItem === "") {
            oidModalidadeEntregaItem = "0";
        }

        this.model.set("OidModalidadeEntrega", oidModalidadeEntregaItem, { silent: false });

        this.ui.idPontoRetiradaItem.prop("disabled", (oidModalidadeEntregaItem !== "39669"));
        if (oidModalidadeEntregaItem !== "39669") {
            this.model.set("IdPontoRetirada", 0, { silent: true });
            this.ui.idPontoRetiradaItem.val(this.model.get("IdPontoRetirada"));
        }

        await definirOidModalidadeEntregaItem({
           oidModalidadeEntregaItem,
           identificadorItem: this.model.get("Identificador"),
           atualizarEstadoLegadoImediatamente: true,
           itemLegado: this.model
        })
    },

    alterarIdPontoRetirada: async function () { // 402445
        var idPontoRetiradaItem = this.ui.idPontoRetiradaItem.val();
        if (idPontoRetiradaItem === "") {
            idPontoRetiradaItem = "0";
        }

        this.model.set("IdPontoRetirada", idPontoRetiradaItem, { silent: false });

        await definirIdPontoRetiradaItem({
            idPontoRetiradaItem,
            identificadorItem: this.model.get("Identificador"),
            atualizarEstadoLegadoImediatamente: true,
            itemLegado: this.model
        })
    },

    alterarCodigoFilialRetirada: async function () {
        var codigoFilialRetirada = this.ui.codigoFilialRetirada.val();

        this.model.set("CodigoFilialRetirada", codigoFilialRetirada, { silent: true });
        this.ui.idPontoRetiradaItem.prop("disabled", (this.model.get("OidModalidadeEntrega" ) != "39669"));  // 402445

        await definirFilialRetiradaItem({
            codigoFilialRetirada,
            identificadorItem: this.model.get("Identificador"),
            atualizarEstadoLegadoImediatamente: true,
            itemLegado: this.model
        })
    },

    alterarCodigoFilialTransferencia: async function () {
        var codigoFilialTransferencia = this.ui.codigoFilialTransferencia.val();

        this.model.set("CodigoFilialTransferencia", codigoFilialTransferencia, { silent: true });

        await definirFilialTransferenciaItem({
            codigoFilialTransferencia,
            identificadorItem: this.model.get("Identificador"),
            atualizarEstadoLegadoImediatamente: true
        })
    },

    alterarTipoFaturamento: async function () {
        var tipoFaturamento = this.ui.tipoFaturamento.val();

        this.model.set("TipoFaturamento", tipoFaturamento, { silent: true });

        await definirTipoFaturamentoItem({
            identificadorItem: this.model.get("Identificador"),
            tipoFaturamento,
            atualizarEstadoLegadoImediatamente: true,
            itemLegado: this.model
        })
    },

    alterarAliquotaIPI: function () {

        var aliquotaIPI = this.ui.aliquotaIPI.val();

        if (!global.validateNumberMaxValue("double", aliquotaIPI)) {
            global.showErrorMessage('O valor do campo "Alíquota IPI" é muito grande e não é suportado.');
            return;
        }

        this.model.set("AliquotaIPI", aliquotaIPI);
    },

    alterarValorIPI: function () {
        var valorIPI = this.ui.valorIPI.val();

        if (!global.validateNumberMaxValue("double", valorIPI)) {
            global.showErrorMessage('O valor do campo "Valor IPI" é muito grande e não é suportado.');
            return;
        }

        this.model.set("ValorIPI", valorIPI);
    },

    dispose: function () {
        this.model.orcamento.off(null, this.habilitarDespesasInclusas, this);
        this.model.off(null, this.atualizar, this);
    }

});

window.EditarItemOrcamentoView = EditarItemOrcamentoView

export {
    EditarItemOrcamentoView
}
